<template>
    <div class="header">
        <el-tag size="large" style="margin-right: 10px;">USDT {{ USDT }}</el-tag>
        <el-tag size="large" style="margin-right: 10px;">USDC {{ USDC }}</el-tag>
        <el-tag size="large" style="margin-right: 10px;">FDUSD {{ FDUSD }}</el-tag>
        <el-tag size="large" style="margin-right: 10px;">BFUSD {{ BFUSD }}</el-tag>
        <el-tooltip content="刷新余额" effect="light" placement="top">
            <el-button icon="Refresh" @click="getBalance()" :loading="loading" />
        </el-tooltip>
    </div>
</template>

<style scoped>
.header {
    margin: 10px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #3a3a3a;
}
</style>

<script setup>
import { ref, toRaw, onMounted } from "vue"
import { ElMessage } from 'element-plus'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'

const systemStore = useSystemStore()
const logStore = useLogStore()
const loading = ref(false)
const USDT = ref("")
const USDC = ref("")
const FDUSD = ref("")
const BFUSD = ref("")

onMounted(async () => {
    getBalance()
})

const getBalance = async () => {
    try {
        loading.value = true

        let result = await systemStore.privateClient.accountInfo()
        USDT.value = Math.round((result.assets.find(x => x.asset === 'USDT').availableBalance) * 10000) / 10000
        USDC.value = Math.round((result.assets.find(x => x.asset === 'USDC').availableBalance) * 10000) / 10000
        FDUSD.value = Math.round((result.assets.find(x => x.asset === 'FDUSD').availableBalance) * 10000) / 10000
        BFUSD.value = Math.round((result.assets.find(x => x.asset === 'BFUSD').availableBalance) * 10000) / 10000
        loading.value = false
    } catch (error) {
        loading.value = false
        ElMessage.error('刷新失败' + error)
        logStore.addLog({
            title: '获取余额失败',
            level: 'error',
            message: error
        })
    }
}
</script>